import React, { useContext, useState } from 'react'
import validator from 'validator'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { UserContext } from '../../../../App'
import { MOBILE_LOCALES } from '../../../../helpers/region'
import { EmployeeFormContext } from './EmployeeForm'

const ContactInfo = ({ formValues, setFormValues, emailDup, setEmailDup }) => {
  const [mobilePhoneError, setMobilePhoneError] = useState(false)
  const { user } = useContext(UserContext)
  const normalizedMobilePhone =
    formValues?.employee?.personnelInfo?.phoneNumber1?.replace(/\s+/g, '')

  const isAllowed = (roles) =>
    roles.some((role) => user.employee?.teams?.includes(role))
  return (
    <Paper sx={{ padding: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="title">Contact Information</Typography>
        </Grid>
        <Grid item xs={12} md={7} xl={5}>
          <TextField
            label="Email Address"
            id="email"
            autoComplete="nope"
            disabled={!user.employee && !!user.employeeApplication}
            fullWidth
            required
            helperText="This email address will be used for logging in to AmbuNet"
            value={formValues?.email ?? ''}
            onChange={(event) => {
              setEmailDup(false)
              setFormValues((prev) => ({ ...prev, email: event.target.value }))
            }}
            error={emailDup}
          />
        </Grid>
        <Grid item xs={12} md={5} xl={4}>
          <TextField
            label="Mobile Phone Number"
            id="mobileNum"
            autoComplete="nope"
            fullWidth
            helperText="This number will be used to send SMS alerts"
            value={formValues.employee?.personnelInfo?.phoneNumber1 ?? ''}
            error={
              normalizedMobilePhone?.length > 10 &&
              !validator.isMobilePhone(normalizedMobilePhone, MOBILE_LOCALES)
            }
            onChange={(event) => {
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    phoneNumber1: event.target.value,
                  },
                },
              }))
            }}
          />
        </Grid>
        {isAllowed(['Governance', 'Personnel']) && (
          <Grid item xs={12}>
            <TextField
              label="Second Contact Number"
              id="secondPhone"
              autoComplete="nope"
              fullWidth
              helperText="This number will appear to staff i.e. medical plans"
              value={formValues.employee?.personnelInfo?.phoneNumber2 ?? ''}
              onChange={(event) => {
                setFormValues((prev) => ({
                  ...prev,
                  employee: {
                    ...prev.employee,
                    personnelInfo: {
                      ...prev.employee?.personnelInfo,
                      phoneNumber2: event.target.value,
                    },
                  },
                }))
              }}
            />
          </Grid>
        )}
      </Grid>
    </Paper>
  )
}

export default ContactInfo
